// @ts-nocheck
import React, { useState } from 'react';

import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Chip from '@mui/material/Chip';
import MuiAlert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';
import { createSharing, uniifyInvite } from 'actions/access';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import useDebouncedPenlyUserSearch from 'hooks/useDebouncedPenlyUserSearch';
import usePensionsInfoInviteText from 'hooks/usePensionsInfoInviteText';
import { useParams } from 'react-router-dom';

const PensionsInfoInviteForm = ({ defaultState = {}, initiator, onClose }) => {
    const { organisationId } = useParams();
    const [name, setName] = useState(defaultState.name ?? '');
    const [email, setEmail] = useState(defaultState.email ?? '');
    const { userExists, handleEmailChange: handleEmailBlur, resetSearch: resetUserSearch, userId } = useDebouncedPenlyUserSearch(organisationId, defaultState.email);
    const [snack, setSnack] = useState();
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user);
    const [message, setMessage] = usePensionsInfoInviteText(userExists, defaultState.message, name, user.fullName );
    console.log('userId', userId);
    // Always use only pension and basic scopes
    const scope = { type: 'self', basic: { all: true }, pension: { all: true } };

    const handleCreateSharing = async () => {
        const firstName = name?.split(' ')[0];
        if(userId) {
            await dispatch(uniifyInvite(organisationId, userId));
        }
        const sharingData = { recipient: { name, email, firstName }, initiator, requestedScopes: [scope], message, type: 'pensionsinfo' };
        const sharing = await dispatch(createSharing(organisationId, sharingData));
        if (!sharing.sharingId) throw new Error('bad');

        setSnack({ message: 'Der er nu blevet sendt en invitation til brugeren.', severity: 'success' });
        setTimeout(() => onClose(), 800);
    };

    return (
        <Grid>
            <h2>Inviter til at dele PensionsInfo</h2>
            <Grid container spacing={ 2 }>
                <Grid item xs={ 6 }>
                    <h3>Modtagerens navn:</h3>
                    <TextField
                        label="Navn"
                        value={ name }
                        onChange={ (e) => setName(e.target.value) }
                        fullWidth
                    />
                </Grid>
                <Grid item xs={ 6 } style={{ position: 'relative' }}>
                    <h3>Modtagerens e-mailadresse:</h3>
                    <TextField
                        label="Email"
                        value={ email }
                        onChange={ (e) => setEmail(e.target.value) }
                        onBlur={ (e) => handleEmailBlur(e.target.value) }
                        onFocus={ resetUserSearch }
                        fullWidth
                    />
                    { userExists && (
                        <Box sx={{ display: 'inline', position: 'absolute', paddingTop: '10px', paddingLeft: '8px' }}>
                            <Chip
                                icon={ <VerifiedUserIcon color={ 'primary' } /> }
                                label={ 'Eksisterende Penly bruger' }
                            />
                        </Box>
                    ) }
                </Grid>
            </Grid>
            <h3>Besked til modtager:</h3>
            <TextField
                label="Skriv en besked til modtageren"
                value={ message }
                onChange={ (e) => setMessage(e.target.value) }
                variant="outlined"
                multiline
                rows={ 10 }
                fullWidth
            />
            <Button
                variant="contained"
                color="primary"
                style={{ display: 'block', marginTop: 24 }}
                onClick={ handleCreateSharing }
            >
                Inviter
            </Button>
            <Snackbar
                open={ !!snack }
                autoHideDuration={ 6000 }
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                onClose={ () => setSnack() }
            >
                <MuiAlert severity={ snack?.severity || 'success' }>{ snack?.message }</MuiAlert>
            </Snackbar>
        </Grid>
    );
};

export default PensionsInfoInviteForm;
